import useFetchApi, { FetchingStatus } from 'hooks/useFetchApi/useFetchApi'
import { useCallback, useEffect } from 'react'
import ipService from 'Services/api/ip.service'
import getEnv from 'utilities/getEnv'
import * as Sentry from '@sentry/react'

const serverEnvironment = getEnv('SERVER_SIDE_ENVIRONMENT')

function useCurrentIP() {
    const [ip, fetchIp, ipStatus] = useFetchApi(ipService.getIP)

    const getCurrentlyIP = useCallback(() => {
        try {
            if (
                serverEnvironment !== undefined &&
                ['Testing', 'UAT', 'Production'].some(
                    (x) => x === serverEnvironment,
                )
            ) {
                fetchIp()
            }
        } catch (err) {
            // throw err
            Sentry.captureException(err)
        }
    }, [fetchIp])

    useEffect(() => {
        getCurrentlyIP()
    }, [getCurrentlyIP])

    return { ip, ipLoading: ipStatus === FetchingStatus.LOADING }
}

export default useCurrentIP
